import Cards from "./Cards";
import DownArrow from "../assets/down-arrow.png";
import { NavLink } from "react-router-dom";

const FeatureWorks = () => {
  return (
    <div className="px-12 xl:px-20 2xl:px-60 pb-10 bg-gradient-to-b from-transparent via-bg-primary to-bg-primary relative">
      <div className="h-80 w-80 bg-transparent-accent absolute top-40 right-10 -z-7 blur-3xl brightness-75"></div>
      <div className="flex flex-row text-lg justify-between">
        <p className="z-10 text-xs sm:text-sm md:text-sm lg:text-base xl:text-base">
          (Check our works)
        </p>
        <NavLink to={"/Projects"}>
          <div className="flex flex-row text-lg hover:text-accent ease-in-out duration-100">
            <p className="z-10 text-xs sm:text-sm md:text-sm lg:text-base xl:text-base">
              Discover more
            </p>
            <img src={DownArrow} alt="Down Arrow" className="h-[15px]" />
          </div>
        </NavLink>
      </div>
      <div className="grid sm:grid-rows sm:gap-4 md:grid-cols-3 z-10">
        {[
          [
            "vidsource1",
            "https://drive.google.com/file/d/1-0VVb19gB1DbfyXuwOl9J472P5nzypmM/preview",
          ],
          [
            "vidsource2",
            "https://drive.google.com/file/d/1MVG3cU5_uuKsJeQaYunAY41GazNtLbku/preview",
          ],
          [
            "vidsource3",
            "https://drive.google.com/file/d/161XBe7J27IdqOlcJXI07EEhvGXOnKGbp/preview",
          ],
        ].map(([key, url]) => {
          return <Cards key={key} url={url} />;
        })}
      </div>
    </div>
  );
};

export default FeatureWorks;
